import RecidivismReportsContainer from './recidivism_reports_container';

const RecidivismReports = RecidivismReportsContainer;
export default RecidivismReports;
